module.exports = __webpack_public_path__ + "img/1440.e8fa6114.jpg";